import ProbabilityBasedSelector from './ProbabilityBasedSelector';

export default function getFeaturedVariant(featuredMessages, url) {
  const filteredMessages = filterFeaturedMessages(featuredMessages, url);
  const variantSelector = new ProbabilityBasedSelector(filteredMessages);
  return variantSelector.select();
}

function filterFeaturedMessages(featuredMessages, url = defaultUrl()) {
  const filteredMessages = featuredMessages.filter(featuredMessage => {
    if (!featuredMessage.include) {
      return true;
    }

    const regex = new RegExp(featuredMessage.include);
    const include = regex.test(url);
    return include;
  });

  return filteredMessages;
}

function defaultUrl() {
  if (typeof window === 'undefined' || !window.location || !window.location.pathname) {
    return null;
  }
  /* eslint-env browser */

  return window.location.pathname;
}



// WEBPACK FOOTER //
// ./src/utils/featured.js